// Source of truth: InputGUI.py :: domestic_policy_options, foreign_policy_options, corruption_options
export const STATE_CHAOS_LEVELS = ['High', 'Medium', 'Low'];
export const DOMESTIC_POLICIES = [
  '1 - Laissez-Faire – minimal government; communities govern themselves',
  '2 - Light Stewardship – rulers provide guidance but interfere little in daily life',
  '3 - Local Autonomy – provinces or clans manage most affairs with loose oversight',
  '4 - Traditional Order – established customs and hierarchies guide governance',
  '5 - Balanced Governance – stable administration balancing authority and freedom',
  '6 - Central Administration – bureaucracy manages law, taxation, and infrastructure',
  '7 - Authoritative Rule – strong leadership prioritizes order and obedience',
  '8 - Controlled Society – strict laws, surveillance, and limited dissent',
  '9 - Police State – heavy enforcement, censorship, and centralized control',
  '10 - Total State Control – government dominates all aspects of life and economy',
];

export const FOREIGN_POLICIES = [
  '1 - Isolationist – avoids outside contact, closes borders',
  '2 - Cautious Neutral – trades carefully, avoids alliances and wars',
  '3 - Defensive Watcher – fortifies borders, responds only when threatened',
  '4 - Pragmatic Trader – seeks stability through commerce and treaties',
  '5 - Diplomatic Builder – forms alliances, mediates disputes',
  '6 - Influence Seeker – uses wealth and favors to control neighbors',
  '7 - Opportunistic Expander – takes land when weakness appears',
  '8 - Militarized Hegemon – maintains dominance through force and intimidation',
  '9 - Conquest State – openly pursues territorial expansion',
  '10 - Imperial War Machine – constant campaigns; war is the economy',
];

export const CORRUPTIONS = [
  '1 - Transparent Rule – laws apply equally, officials are accountable',
  '2 - Mostly Honest – rare bribery, punished when discovered',
  '3 - Minor Favor Trading – small "gifts" happen, but not required',
  '4 - Quiet Nepotism – friends get jobs, justice slightly uneven',
  '5 - Routine Bribery – bribes common for speed and access',
  '6 - Institutional Corruption – courts and officials regularly bought',
  '7 - Predatory Governance – officials extract wealth as a lifestyle',
  '8 - Criminal Administration – state functions like a cartel',
  '9 - Rot From the Throne – corruption flows from the top openly',
  '10 - Total Kleptocracy – the entire state exists to steal from its people',
];
